export class ConfirmationCancelAction {
  public static readonly type = '[Project/Forms/List] ConfirmationCancelAction';
}
